import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";

interface WebhookEndpointRawSecretModalProps {
  show: boolean;
  rawSecret: string;
  endpointName: string;
  onClose: () => void;
}

const WebhookEndpointRawSecretModal: React.FC<WebhookEndpointRawSecretModalProps> = ({
  show,
  rawSecret,
  endpointName,
  onClose,
}) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(rawSecret);
  };

  return (
    <CModal show={show} onClose={onClose} size="lg">
      <CModalHeader closeButton>
        <CModalTitle>Secreto del Webhook: {endpointName}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <div className="alert alert-warning">
                <strong>Atención:</strong> Esta es la única vez que se mostrará
                el secreto completo del webhook. Cópielo y guárdelo en un lugar
                seguro. Se usa para verificar la firma HMAC-SHA256 de cada
                entrega.
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <div
                className="p-3 bg-dark text-white rounded d-flex align-items-center justify-content-between"
                style={{ wordBreak: "break-all", fontFamily: "monospace" }}
              >
                <span>{rawSecret}</span>
                <CButton
                  color="light"
                  size="sm"
                  className="ml-3 flex-shrink-0"
                  onClick={copyToClipboard}
                >
                  <i className="fa fa-copy"></i> Copiar
                </CButton>
              </div>
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol sm="12">
              <p className="text-muted small">
                Cada request llegará con el header{" "}
                <code>X-Webhook-Signature: sha256=&lt;firma&gt;</code>. Verificá
                la firma calculando HMAC-SHA256 del body con este secreto.
              </p>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={onClose}>
          Entendido, ya lo copié
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default WebhookEndpointRawSecretModal;
